export default __webpack_public_path__ + "static/media/Google-Gemini.859cfc9e.png";